import { render, staticRenderFns } from "./SpinnerLoader.vue?vue&type=template&id=e7994f3c&"
import script from "./SpinnerLoader.vue?vue&type=script&lang=js&"
export * from "./SpinnerLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports